import React, { useContext, useState } from "react";
import { AREA_OF_INTEREST } from "../../../../AppData/AreaOfInterest";
import { Profession_DATA } from "../../../../AppData/Profession";
import { SPECIALITY_DATA } from "../../../../AppData/Speciality";
import LoaderImg from "../../../../assets/images/Loader.gif";
import lockIconImg from "../../../../assets/images/lockIcon.png";

import { authContext } from "../../../../contexts/AuthContext/AuthContextProvider";
import { windowOpenUrl } from "../../../../utils/common.utils";
import styles from "./PersonalDetails.module.scss";
import {
  whiteListCountries,
  CITY_DEBOUNCE,
  CITY_FETCH_MIN_CHAR,
} from "../../../../AppConstants/Constants";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";

// const sessionToken = new window.google.maps.places.AutocompleteSessionToken();

const PersonalDetails = ({ old = undefined }) => {
  const {
    state,
    handleFormDetails,
    handleRegisterBtn,
    updateProfile,
    updateMultipleState,
  } = useContext(authContext);

  const { errors, formDetails, loading } = state;
  const { firstName, profession, speciality, areaOfInterest } = formDetails;
  const [city, setCity] = useState("");

  const handlePlaceSelect = async (address, placeId, suggestion) => {
    try {
      let resp = await geocodeByAddress(address);
      let addressObject = resp[0];

      let lat = addressObject.geometry?.location.lat();
      let lng = addressObject.geometry?.location.lng();
      if (!lat) {
        lat = 20.5937;
      }
      if (!lng) {
        lng = 78.9629;
      }

      let locationResult = {
        state: "",
        city: "",
        country: "",
        pincode: null,
        location: {
          lat,
          lng,
        },
      };

      addressObject.address_components.forEach((element) => {
        if (element.types.indexOf("locality") !== -1) {
          locationResult.city = element.long_name;
        } else if (
          element.types.indexOf("administrative_area_level_1") !== -1
        ) {
          locationResult.state = element.long_name;
        } else if (element.types.indexOf("country") !== -1) {
          locationResult.country = element.long_name;
        } else if (element.types.indexOf("postal_code") !== -1) {
          locationResult.pincode = element.long_name;
        }
      });
      if (!locationResult.city) {
        locationResult.city = locationResult.state;
      }
      setCity(address);
      handleFormDetails({ city: locationResult });
    } catch (error) {
      console.error(error);
    }
  };

  const onCityError = (errCode) => {
    let error = "";
    switch (errCode) {
      case "ZERO_RESULTS":
        error = "No result found.";
        break;
      default:
        error = "Some internal error occurred.";
        break;
    }
    updateMultipleState({ errors: { city: error } });
  };

  return (
    <div className={styles["personalDetail-form"]}>
      {old && (
        <>
          <h1>Almost There</h1>
          <p>
            Hey {firstName}, please share a few more professional details about
            you to register on Docflix.
          </p>
        </>
      )}
      <div className={styles["profiledetails"]}>
        <div className={styles["input-group"]}>
          <label htmlFor="profession">Profession</label>
          <select
            id="profession"
            name="profession"
            className="form-control"
            defaultValue="Select Your Profession"
            value={profession}
            onChange={(e) => handleFormDetails({ profession: e.target.value })}
            required
          >
            <option value="" hidden>
              Select Your Profession
            </option>
            {Profession_DATA.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
          {errors.profession && (
            <div className="error">{errors.profession}</div>
          )}
        </div>

        <div className={styles["input-group"]}>
          <label htmlFor="speciality">Speciality</label>
          <select
            id="speciality"
            name="speciality"
            className="form-control"
            defaultValue="Select Your Speciality"
            value={speciality}
            onChange={(e) => handleFormDetails({ speciality: e.target.value })}
            required
          >
            <option value="" hidden>
              Select Your Speciality
            </option>
            {SPECIALITY_DATA.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
          {errors.speciality && (
            <div className="error">{errors.speciality}</div>
          )}
        </div>

        <div className={styles["input-group"]}>
          <label htmlFor="areaOfInterest">Area of Interest</label>
          <select
            id="areaOfInterest"
            name="areaOfInterest"
            className="form-control"
            defaultValue={"Select Your Area of Interest"}
            value={areaOfInterest}
            onChange={(e) =>
              handleFormDetails({ areaOfInterest: e.target.value })
            }
            required
          >
            <option value="" hidden>
              Select Your Area of Interest
            </option>
            {AREA_OF_INTEREST.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
          {errors.areaOfInterest && (
            <div className="error">{errors.areaOfInterest}</div>
          )}
        </div>

        <div className={styles["input-group"]}>
          <label htmlFor="city">City</label>

          <PlacesAutocomplete
            onError={onCityError}
            value={city}
            onChange={(value) => {
              setCity(value);
            }}
            onSelect={handlePlaceSelect}
            searchOptions={{
              // sessionToken: sessionToken,
              types: ["(cities)"],
              fields: ["address_components"],
              // componentRestrictions: {
              //   country: whiteListCountries,
              // },
            }}
            debounce={CITY_DEBOUNCE}
            shouldFetchSuggestions={city.length >= CITY_FETCH_MIN_CHAR}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <div style={{ position: "relative" }}>
                <input
                  style={{ color: "#888888" }}
                  className="form-control"
                  {...getInputProps({
                    placeholder: "Please enter full city name",
                    name: "city",
                    id: "city",
                    required: true,
                  })}
                />
                <div
                  style={{
                    position: "absolute",
                    zIndex: "10",
                    border: `${
                      suggestions.length === 0
                        ? "0px"
                        : "1px solid rgba(255, 255, 255, 0.4)"
                    }`,
                    width: "100%",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {loading && <div>Loading...</div>}

                  {suggestions.map((suggestion, index) => {
                    const style = {
                      backgroundColor: suggestion.active
                        ? "#eb4547"
                        : "rgba(44, 64, 103, 1)",
                      color: "#ffff",
                      padding: "0.5rem",
                      cursor: "pointer",
                    };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          style,
                        })}
                        key={index}
                      >
                        <option
                          style={{ width: "100%" }}
                          key={suggestion.description}
                          value={suggestion.description}
                        >
                          {suggestion.description}
                        </option>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>

          {errors.city && <div className="error">{errors.city}</div>}
        </div>

        {old ? (
          <button
            onClick={handleRegisterBtn}
            disabled={loading}
            className={`btn ${styles["register-btn"]}`}
            style={{ marginTop: "5px" }}
          >
            {loading ? (
              <img src={LoaderImg} alt="" height="100%" />
            ) : (
              "Register"
            )}
          </button>
        ) : (
          <div className={styles.premiumBtn}>
            <div>
              <img src={lockIconImg} alt="" />
              <div>
                Feel safe with us, your information is not shared with anyone.
                For more read our&nbsp;
                <span
                  onClick={() =>
                    windowOpenUrl(
                      "https://www.mankindpharma.com/privacy-policy"
                    )
                  }
                >
                  Privacy Policy
                </span>
              </div>
            </div>
            <button
              onClick={updateProfile}
              disabled={loading}
              className={`btn ${styles["register-btn"]}`}
              style={{ marginTop: "5px" }}
            >
              {loading ? (
                <img src={LoaderImg} alt="" height="100%" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalDetails;
